/**
 * Format numbers compactly:
 * < 1,000 -> standard formatted (e.g. 0, 1, 999)
 * 1,000 to 999,999 -> K (e.g. 1K, 20.8K, 44.4K, 104.8K)
 * 1,000,000 to 999,999,999 -> M (e.g. 1M, 1.18M, 1.25M)
 * >= 1,000,000,000 -> B (e.g. 1B, 2.5B)
 */
export const formatCompactNumber = (value, maxDecimals = 1) => {
  if (value === null || value === undefined || value === '') return '0';
  const num = Number(value);
  if (isNaN(num)) return String(value);
  const abs = Math.abs(num);

  if (abs < 1000) {
    return num.toLocaleString();
  }

  if (abs >= 1_000_000_000) {
    const val = num / 1_000_000_000;
    const str = val.toFixed(maxDecimals).replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1');
    return `${str}B`;
  }

  if (abs >= 1_000_000) {
    const d = maxDecimals < 2 ? 2 : maxDecimals;
    const val = num / 1_000_000;
    const str = val.toFixed(d).replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1');
    return `${str}M`;
  }

  const kVal = (num / 1_000).toFixed(maxDecimals);
  if (parseFloat(kVal) >= 1000) {
    return '1M';
  }
  const str = parseFloat(kVal).toString();
  return `${str}K`;
};

export default formatCompactNumber;
